/* eslint-disable no-debugger */
/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ILobasProductSpecificationViewProps } from './lobas-product-specification';

const ProductSpecificationView: React.FC<ILobasProductSpecificationViewProps> = props => {
    const {
        ProductSpecification,
        ProductSpecificationTableProps,
        ProductSpecificationTableBodyProps,
        productSpecificationResult,
        config
    } = props;

    const rowdata =
        productSpecificationResult &&
        ArrayExtensions.hasElements(productSpecificationResult) &&
        productSpecificationResult.filter(
            row =>
                !ObjectExtensions.isNullOrUndefined(row) &&
                !config.exludedAttributes?.includes(row.props.productName) &&
                !(row.props.cellData.props.dangerouslySetInnerHTML === undefined && row.props.cellData.props.children === undefined) &&
                !(row.props.cellData.props.children === 0)
        );

    return rowdata && ArrayExtensions.hasElements(rowdata) ? (
        <Module {...ProductSpecification}>
            {props.title}
            <Node {...ProductSpecificationTableProps}>
                <Node {...ProductSpecificationTableBodyProps}>{rowdata}</Node>
            </Node>
        </Module>
    ) : null;
};

export default ProductSpecificationView;
